







































































import { Component, Ref, Watch, Prop } from "vue-property-decorator";
import Vue from "vue";
import FactorListInput from "@/components/Lists/FactorListInput.vue";
import CardTitle from '@/components/common/CardTitle.vue';

@Component({
    components: {FactorListInput, CardTitle}
})
export default class FactorListInputDialog extends Vue{

    @Prop({default: "mdi-file-tree", type: String})
    iconName!: string;

    @Prop({default: "", type: String})
    btnText!: string;

    @Prop({default: "", type: String})
    btnClass!: string;


    @Prop({default: true, type: Boolean})
    icon!: boolean;

    @Prop({default: true, type: Boolean})
    small!: boolean;

    @Ref('child')
    factorListinput: any;

    private saveAsNew = false;
    private save = false;
    private clear = false;
    private loading = false;
    private show = false;
    private editing = false;

    @Watch('show')
    private watchShow() {
        this.editing = false;
    }
    

    private cancel(){
        this.clear = true;
        this.show = false;
    }
    private saveFactor(){
        this.save = true;
        this.loading = true;
    }

    private saveFactorAsNew() {
        this.saveAsNew = true;
        this.loading = true;
        this.$emit('close');
        this.editing = false;
    }

    private clearFactor() {
        this.clear = true;
        this.editing = false;
    }
}
